import NewsPage from './page-types/news-page'
import ContentPage from './page-types/content-page'

export default {
  content_page: ContentPage,
  news_page: NewsPage,
  video_page: ContentPage,
}
